export { PostDetailScreen } from './PostDetailScreen';
